import React from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form';
import {connect} from 'react-redux';
import {FieldTxt, FieldSelect, FieldCheckbox, FieldMedia} from '../../../components/Form/wh-field';
import FieldContents from '../../../components/Form/wh-contents';
import {Card, CardHeader, CardBody, CardFooter, Form, Alert, Button, Row, Col, ButtonGroup} from 'reactstrap';
import LaddaButton, {EXPAND_LEFT} from 'react-ladda';
import Loading from '../../../components/Loading';
import ApiConfig from '../../../constants/ApiConfig';
import Parameter from '../../../constants/parameters';
import WhFinder from '../../../components/Form/wh-finder';
import DocumentCollection from './DocumentCollection'

class FormEdit extends React.Component {

    constructor(props) {

        super(props);


    }

    componentWillMount() {



    }


    render() {

        const {error, handleSubmit, pristine, reset, submitting, initialValues} = this.props;


        return (

            <Form onSubmit={handleSubmit} className="form-vertical">

                <Row>
                    <Col sm="8" xs={12}>

                        <Field
                            label={false}
                            name="title"
                            component={FieldTxt}
                            type="text"
                            placeholder={'Saisir un titre'}
                            bsSize={'lg'}
                        />

                        <Field
                            label='Citation'
                            name="quote"
                            component={FieldTxt}
                            type="text"
                            placeholder={'Saisir un titre'}
                            bsSize={'lg'}
                        />

                       <FieldArray name="contents" component={FieldContents} />


                    </Col>
                    <Col sm="4" xs={12}>
                        <Card>
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> Edition

                                <div className="card-actions">
                                     {/*<a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'}></i></a> */}
                                </div>

                            </CardHeader>

                            <CardBody>

                                <Field
                                    label="Résumé : "
                                    name="summary"
                                    component={FieldTxt}
                                    type="textarea"
                                />

                                <Field
                                    label="Mail de contact: "
                                    name="mailtoUrl"
                                    component={FieldTxt}
                                    type="text"
                                />

                                <Field
                                    label="Date de publication : "
                                    name="publicationDate"
                                    component={FieldTxt}
                                    type="date"
                                />

                                <Field
                                    label="Mettre en avant sur la home : "
                                    name="topHomeDate"
                                    component={FieldTxt}
                                    type="date"
                                />

                                <Field
                                    label="Type *: "
                                    name="postType"
                                    component={FieldSelect}
                                    type="select"
                                    options={this.props.postTypeLst}
                                    multi={false}
                                    type="select"
                                />

                                <Field
                                    label="Template : "
                                    name="postListTemplate"
                                    component={FieldSelect}
                                    type="select"
                                    options={this.props.postListTemplateLst}
                                />

                                <Field
                                    label="site web"
                                    name="webSite"
                                    component={FieldCheckbox}
                                    type="checkbox"
                                />
                                <Field
                                    label="Publier"
                                    name="published"
                                    component={FieldCheckbox}
                                    type="checkbox"
                                />

                                <FieldArray
                                    name="documents"
                                    component={DocumentCollection}
                                />

                                {error && <Alert color="danger"><div dangerouslySetInnerHTML={{__html: error}} /></Alert>}

                            </CardBody>

                            <CardFooter>

                                <LaddaButton
                                    className="btn btn-success btn-ladda"
                                    loading={submitting}
                                    data-style={EXPAND_LEFT}
                                    type={'submit'}
                                >
                                    <i className="fa fa-save"></i> Enregistrer </LaddaButton>

                            </CardFooter>

                        </Card>


                        <WhFinder name={'banner'} title={'bandeau (1580x700'} change={this.props.change} initialValues={initialValues} />
                        <WhFinder name={'thumb'} title={'Thumbnail (455x234)'} change={this.props.change} initialValues={initialValues} />

                    </Col>
                </Row>



            </Form>

        );

    }

};


FormEdit = reduxForm({
    form: 'FormEditPage'
})(FormEdit);

export default FormEdit




// WEBPACK FOOTER //
// ./src/views/Cms/Posts/Form.js